<template>
<div id="testimony">
      
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>Veja o que estão falando da gente</h2>
            <carousel class="carousel" :autoplay=true :perPage=1 :paginationEnabled=true :autoplayHoverPause=true :loop=true :autoplayTimeout=5000>

              <slide class="slide">
                <div class="row">
                  <div class="col-md-8">
                    <p>
                    “A plataforma Click2giv nos proporciona divulgação do nosso trabalho, além de levar as nossas propostas 
                    mais longe e a mais pessoas. Por outro lado, no que diz respeito à captação de recursos, tem um papel 
                    fundamental, pois é uma ferramenta acessível às pessoas que desejam fazer suas doações, com maior facilidade 
                    e de acordo com suas possibilidades.”
                    <br><b>(José Carlos de Gomes Oliveira - Presidente Centro Social Roger Cunha)</b>
                    </p>
                  </div>
                  <div class="col-md-4">
                    <img :src="testimony6"/>
                  </div>
                </div>
              </slide>

              <slide class="slide">
                <div class="row">
                  <div class="col-md-8">
                    <p>
                    “Não temos dúvida que grande parte do sucesso da campanha da AESB/AACD se deveu a facilidade de acesso e 
                    a credibilidade da plataforma Click2giv. Nos sentimos muito satisfeitos e alegres de saber que temos pessoas 
                    envolvidas, de diversas áreas, para promover o bem e, no caso da plataforma, para facilitar a divulgação e 
                    obtenção de recursos para projetos sociais. Exemplo que todos podemos ser agentes de transformação, que a cada
                     dia certamente terá mais seguidores”
                    <br><b>(Paulo Dutra - Associação de Ex-Alunos Escola Senai Suiço Brasileira)</b>
                    </p>
                  </div>
                  <div class="col-md-4">
                    <img :src="testimony4"/>
                  </div>
                </div>
              </slide>

              <slide class="slide">
                <div class="row">
                  <div class="col-md-8">
                    <p>
                    “Com a transformação digital a plataforma Click2giv facilitou  o processo de Captação de Recursos da AFAGO-SP, 
                    apresentando uma ferramenta simples, transparente para a divulgação de nossas campanhas, contribuindo para que 
                    um número ilimitado de pessoas conheça as nossas ações e doe para os projetos através de um clique.”
                    <br><b>(Ana Paula Dias - Gestora AFAGO-SP)</b>
                    </p>
                  </div>
                  <div class="col-md-4">
                    <img :src="testimony5"/>
                  </div>
                </div>
              </slide>

              <slide class="slide">
                <div class="row">
                  <div class="col-md-8">
                    <p>
                    ¨”A Click2giv possui uma equipe sempre pronta a nos ajudar a entender nossos desafios
                    e principalmente propor soluções simples, práticas e efetivas. A grande experiência
                    tanto no mundo corporativo quanto no terceiro setor, é sem dúvida um diferencial 
                    importante para o sucesso da nossa parceria.” <br><b>(Any Bittar - Diretora Executiva Projeto Casulo)</b>
                    </p>
                  </div>
                  <div class="col-md-4">
                    <img :src="testimony1"/>
                  </div>
                </div>
              </slide>

              <slide class="slide">
                <div class="row">
                  <div class="col-md-4">
                    <img :src="testimony2"/>
                  </div>
                  <div class="col-md-8">
                    <p>
                    “A Click2giv é uma verdadeira plataforma social. As organizações sociais inserem
                    seus projetos e recebem 100% de retorno das doações, descontadas apenas as taxas
                    de operação bancária. Além da plataforma não cobrar nenhuma taxa das organizações,
                    os fundadores estão empenhados em conhecer de perto o trabalho de cada organização,
                    além de ajudarem dando dicas e informações importantes para que o seu projeto tenha
                    sucesso.” <br><b>(Eliane Miada - Presidente ADD Associação Desportiva para Deficientes)</b>
                    </p>
                  </div>
                </div>
              </slide>

              <slide class="slide">
                <div class="row">
                  <div class="col-md-8">
                    <p>
                    "Neste mais de um ano junto com a Click2giv descobrimos que a plataforma é muito
                    mais que uma ferramenta para recebimento de doações sem cobrança de taxas, 
                    a verdadeira essência da click2giv  é conectar pessoas que estão fazendo o bem, 
                    com pessoas que querem fazer o bem. Nosso projeto já cresceu muito com as conexões 
                    feitas pela click2giv, posso citar como grandes avanços a oficialização da nossa ONG 
                    e a otimização do projeto da cadeira Julietti, tudo graças às conexões da plataforma" 
                    <br><b>(Guilherme Simões - Fundador Projeto Montanha para Todos)</b>
                    </p>
                  </div>
                  <div class="col-md-4">
                    <img :src="testimony3"/>
                  </div>
                </div>
              </slide>
            </carousel>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import casulo from '../../assets/images/casulo.png';
import add from '../../assets/images/add.jpeg';
import montanha from '../../assets/images/montanha.jpeg';
import aesb from '../../assets/images/AESB.jpg';
import afago from '../../assets/images/AFAGO.png';
import rogercunha from '../../assets/images/rogercunha.png';

export default {
  components: {
    Carousel,
    Slide,
  },
  data(){
    return {
      testimony1: casulo,
      testimony2: add,
      testimony3: montanha,
      testimony4: aesb,
      testimony5: afago,
      testimony6: rogercunha
    }
  }
}
</script>

<style scoped lang="scss">
#testimony{
  background-color: #fff;
  padding-top: 40px;
  padding-bottom: 40px;

  h2{
    font-size: 28px;
    color: #00AE39;
    width: 100%;
    text-align: center;
    font-family: RalewayRegular;
  }
  .slide{
    margin-top: 20px;
    img{
      width: 230px;
      float: right;
      margin-right: 50px;
    }
    p{
      padding: 30px;
    }
    b{
      font-family: RalewayBold;
    }
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/home/TestimonySection.vue